import apiClient from './apiClient';

export const flashcardsApi = {
  async listMyDecks() {
    const res = await apiClient.get('/api/decks');
    return res.data.decks as Array<any>;
  },
  async listClassDecks(classId: string) {
    const res = await apiClient.get(`/api/decks/class/${classId}`);
    return res.data.decks as Array<any>;
  },
  async listUserPublicDecks(userId: string) {
    const res = await apiClient.get(`/api/decks/user/${userId}`);
    return res.data.decks as Array<any>;
  },
  async createDeckFromPdfs(files: File[], classId: string, isPublic: boolean, title?: string) {
    const form = new FormData();
    files.forEach((f) => form.append('files', f));
    form.append('class_id', classId);
    form.append('public', String(isPublic));
    if (title && title.trim()) form.append('title', title.trim());
    const res = await apiClient.post('/api/decks/from-pdfs', form, { headers: { 'Content-Type': 'multipart/form-data' } });
    return res.data;
  },
  async getDeck(deckId: string) {
    const res = await apiClient.get(`/api/decks/${deckId}`);
    return res.data;
  },
  async getVotes(deckId: string) {
    const res = await apiClient.get(`/api/decks/${deckId}/votes`);
    return res.data as { count: number; user_has_voted: boolean };
  },
  async addVote(deckId: string) {
    const res = await apiClient.post(`/api/decks/${deckId}/votes`);
    return res.data as { count: number; user_has_voted: boolean };
  },
  async removeVote(deckId: string) {
    const res = await apiClient.delete(`/api/decks/${deckId}/votes`);
    return res.data as { count: number; user_has_voted: boolean };
  },
  async getComments(deckId: string) {
    const res = await apiClient.get(`/api/decks/${deckId}/comments`);
    return res.data.comments as Array<{ id: string; user_id: string; text: string; created_at: string; parent_id?: string | null; author?: { first_name: string; last_name: string } }>;
  },
  async addComment(deckId: string, content: string, parentId?: string) {
    const body = parentId ? { content, parent_id: parentId } : { content };
    const res = await apiClient.post(`/api/decks/${deckId}/comments`, body);
    return res.data;
  },
  async deleteComment(deckId: string, commentId: string) {
    const res = await apiClient.delete(`/api/decks/${deckId}/comments/${commentId}`);
    return res.data;
  },
  async deleteDeck(deckId: string) {
    const res = await apiClient.delete(`/api/decks/${deckId}`);
    return res.data;
  },
};
